import coreToggle from '@nrk/core-toggle'
import { nrkUserLoggedin, nrkClose } from '@nrk/core-icons'
import { connect } from '@nrk/nrkno-login-connector'

export function initialize() {
  if (typeof document === 'undefined') return

  coreToggle('.nrk-masthead__bars, .nrk-masthead__more', { popup: true })

  const loginLink = document.querySelector('.nrk-masthead__user a')

  const cookieName = 'nrkno-cookie-information'
  const allCoookies = document.cookie.split(';')

  const isApp = window.location.search.indexOf('header=off') > 0
  let showCookieBanner = isApp ? false : true
  allCoookies.forEach((cookie) => {
    if (cookie.trim().substring(0, cookieName.length) === cookieName) {
      showCookieBanner = false
    }
  })

  if (loginLink) {
    connect((user) => {
      if (user) {
        const span = document.createElement('span')
        const canReplaceState = window.history && window.history.replaceState
        const isAutoLogin = window.location.search.indexOf('autoLogin=true') >= 0

        span.textContent = user.name
        loginLink.innerHTML = nrkUserLoggedin
        loginLink.appendChild(span)

        if (isAutoLogin) {
          const loginBanner = document.body.insertAdjacentElement('afterbegin', document.createElement('div'))

          loginBanner.className = 'nrk-masthead__info-banner nrk-masthead__info-banner--login'
          if (showCookieBanner) {
            loginBanner.style = `display: none;`
          }
          loginBanner.innerHTML = `<button><span class="nrk-sr">Lukk</span>${nrkClose}</button><span class="nrk-masthead__semibold">Hei</span>, du er nå logget inn på nrk.no, fordi du allerede er innlogget et annet sted hos NRK`
          loginBanner
            .querySelector('button')
            .addEventListener('click', () => loginBanner.parentElement.removeChild(loginBanner))
          loginBanner.querySelector('.nrk-masthead__semibold').textContent = `Hei ${user.name}` // Use textContent for security

          if (canReplaceState) {
            const href = window.location.href.replace(/autoLogin=true&?/, '').replace(/[?|&]$/, '')
            window.history.replaceState(window.history.state, document.title, href)
          }
        }
      }
      loginLink.removeAttribute('hidden')
    })
  }

  if (showCookieBanner) {
    const cookieDialog = document.body.insertAdjacentElement('afterbegin', document.createElement('div'))

    cookieDialog.className = 'nrk-masthead__info-banner nrk-masthead__info-banner--cookie'
    cookieDialog.innerHTML = `<span class="nrk-masthead__semibold">Vi bruker informasjonskapsler</span> for å forbedre brukeropplevelsen. <a href="https://info.nrk.no/informasjonskapsler">Besøk vår informasjonsside</a> for mer detaljer, eller finn lenken i bunnen av NRK.no.<button><span class="nrk-sr">Lukk</span>${nrkClose}</button>`
    cookieDialog.querySelector('button').addEventListener('click', () => {
      cookieDialog.parentElement.removeChild(cookieDialog)
      const loginBanner = document.querySelector('.nrk-masthead__info-banner--login')
      if (loginBanner) {
        loginBanner.removeAttribute('style')
      }
      const expirationDate = new Date()
      expirationDate.setTime(expirationDate.getTime() + 1000 * 24 * 60 * 60 * 1000)
      document.cookie = `${cookieName}=1; expires=${expirationDate.toUTCString()}; path=/;`
    })
  }

  handleJumpToContent()
}
/**
 * Find, if any, the disabled jumpAnchor and "enable" it.
 */
function handleJumpToContent () {
  const jumpAnchor = document.querySelector('#nrk-masthead__jump-anchor[class~="nrk-masthead__jump-anchor--disabled"]')

  if (!jumpAnchor) {
    return
  }

  const mainElement = getMainElement()
  if (!mainElement) {
    // retry incase dom not loaded yet
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleJumpToContent)
    }
    return
  }

  if (!mainElement.id) {
    mainElement.id = 'innhold'
  }

  jumpAnchor.setAttribute('href', `#${mainElement.id}`)
  jumpAnchor.classList.remove('nrk-masthead__jump-anchor--disabled')
  jumpAnchor.classList.add('nrk-masthead__jump-anchor--enabled')
  // no-op if listener has not been added
  document.removeEventListener('DOMContentLoaded', handleJumpToContent)
}

/**
 * @returns {Element | undefined} the `main` element or the _best-effort_ main element.
 */
function getMainElement () {
  const mainElement = document.querySelector('main, [role="main"], #innhold')

  if (mainElement) {
    return mainElement
  }

  const bestEffortMainElement = document.querySelector('nrkno-player, article a, a > figure')

  if (!bestEffortMainElement) {
    return
  }

  if (bestEffortMainElement.tagName === 'FIGURE') {
    // return the parent/`a` tag
    return bestEffortMainElement.parentElement
  }

  return bestEffortMainElement
}
